import { lazy } from 'react';

import { Route } from 'react-router-dom';

import { ROUTES } from '@constants/routes';
import PublicLayout from '@layouts/PublicLayout';
import RequireGuest from '@routes/guards/RequireGuest';

const LoginPage = lazy(() => import('@pages/Login'));

const PublicRoutes = (
  <Route element={<PublicLayout />}>
    <Route element={<RequireGuest />}>
      <Route path={ROUTES.LOGIN} element={<LoginPage />} />
    </Route>
  </Route>
);

export default PublicRoutes;
